import { RotateLeft } from "@mui/icons-material";
import {
	Checkbox,
	FormControl,
	FormControlLabel,
	InputLabel,
	ListItemText,
	MenuItem,
	Select,
	Switch,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import { Dispatch, SetStateAction } from "react";
import Sidebar from "../../Components/Sidebar/Sidebar";
import SidebarButton from "../../Components/Sidebar/SidebarButton";
import SidebarForm from "../../Components/Sidebar/SidebarForm";
import SidebarGroup from "../../Components/Sidebar/SidebarGroup";
import { UserRole, UserReportType } from "../../system/Domain";
import useUser from "../../system/useUser";
import { formatUserReportType, supportedUserReportTypes } from "./UserReportListItem";
import { ReportsQuery } from "./ReportsPage";

interface Props {
	query: ReportsQuery;
	setQuery: Dispatch<SetStateAction<ReportsQuery>>;
	resetQuery: () => ReportsQuery;
}

export default ({ query, setQuery, resetQuery }: Props) => {
	const [, , hasRole] = useUser();
	const isAldAdmin = hasRole(UserRole.AldAdmin);

	const selectedTypes = query.types ?? supportedUserReportTypes;

	return (
		<Sidebar>
			{isAldAdmin && (
				<SidebarGroup>
					<SidebarForm>
						<FormControl fullWidth>
							<FormControlLabel
								control={
									<Switch
										checked={!!query.all}
										onChange={(e) =>
											setQuery((q) => ({
												...q,
												all: e.target.checked,
											}))
										}
									/>
								}
								label={query.all ? "Alle Reports" : "Mir zugewiesen"}
							/>
						</FormControl>
					</SidebarForm>
				</SidebarGroup>
			)}
			<SidebarGroup>
				<SidebarForm>
					<FormControl variant="standard" fullWidth>
						<DatePicker
							format="DD.MM.YYYY"
							label="Zeitraum ab"
							value={query.dateFrom ? moment(query.dateFrom) : null}
							slotProps={{ textField: { variant: "standard" } }}
							onChange={(d: any) =>
								setQuery((q) => ({
									...q,
									dateFrom: d ? moment(d).startOf("day").toISOString(true) : undefined,
								}))
							}
						/>
					</FormControl>

					<FormControl variant="standard" fullWidth>
						<InputLabel>Report-Typ</InputLabel>
						<Select
							multiple
							value={selectedTypes}
							renderValue={(selected: UserReportType[]) =>
								selected.length === supportedUserReportTypes.length
									? "Alle"
									: selected.map(formatUserReportType).join(", ")
							}
							onChange={(e) => {
								const value = e.target.value as UserReportType[];

								setQuery((q) => ({
									...q,
									types: value.length === 0 ? supportedUserReportTypes : value,
								}));
							}}
						>
							{supportedUserReportTypes.map((type) => (
								<MenuItem key={type} value={type}>
									<Checkbox checked={selectedTypes.includes(type)} />
									<ListItemText primary={formatUserReportType(type)} />
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</SidebarForm>
			</SidebarGroup>
			<SidebarGroup>
				<SidebarButton startIcon={<RotateLeft />} label="Filter zurücksetzen" onClick={resetQuery} />
			</SidebarGroup>
		</Sidebar>
	);
};
